/* Size details under the size picker (snippets/pb-size-info.liquid):
 * price + "Custom" ribbon on each size button, live measurement box for the selected size. */
(function () {
  function sizeFieldset(box) {
    var scope = box.closest('.hdt-product-info__list') || document;
    return scope.querySelector('.hdt-product-form__input.is-style-size');
  }

  function valueOf(el) {
    var input = el.previousElementSibling;
    if (input && input.tagName === 'INPUT') return input.value;
    if (el.hasAttribute('value')) return el.getAttribute('value');
    var clone = el.cloneNode(true);
    clone.querySelectorAll('.sr-only, .pb-size-price, .pb-size-custom').forEach(function (n) { n.remove(); });
    return clone.textContent.trim();
  }

  function decorate(fieldset, data) {
    fieldset.querySelectorAll('.hdt-product-form_value').forEach(function (el) {
      var key = valueOf(el).toUpperCase();
      if (data.prices[key] && !el.querySelector('.pb-size-price')) {
        var p = document.createElement('span');
        p.className = 'pb-size-price';
        p.textContent = data.prices[key];
        el.appendChild(p);
      }
      if (data.custom.indexOf(key) > -1 && !el.querySelector('.pb-size-custom')) {
        var c = document.createElement('span');
        c.className = 'pb-size-custom';
        c.textContent = data.custom_label;
        el.appendChild(c);
      }
    });
  }

  function selected(fieldset) {
    var checked = fieldset.querySelector('input:checked');
    if (checked) return checked.value;
    var btn = fieldset.querySelector('[aria-selected="true"]');
    if (btn) return btn.getAttribute('value') || btn.textContent.trim();
    var label = fieldset.querySelector('[update-value]');
    return label ? label.textContent.trim() : '';
  }

  function render(box, fieldset, data) {
    var key = selected(fieldset).toUpperCase();
    var d = data.sizes[key];
    if (!d) { box.hidden = true; return; }
    box.hidden = false;
    var regions = box.querySelector('[data-size-regions]');
    regions.innerHTML = (data.regions[key] || '').split('|').map(function (part) {
      var m = part.trim().match(/^([^:]+):\s*(.*)$/);
      return m ? '<b>' + m[1].trim() + '</b> : ' + m[2].trim() : part.trim();
    }).join('  |  ');
    regions.hidden = !data.regions[key];
    var labels = data.labels || ['Shoulder', 'Sleeve', 'Length', '1/2 Chest'];
    box.querySelector('[data-size-measure]').innerHTML = d.map(function (v, i) {
      return '<strong>' + String(labels[i] || '').trim().toUpperCase() + '</strong>: ' + v;
    }).join(', ');
  }

  function init(box) {
    if (box.dataset.ready) return;
    var json = box.querySelector('script[type="application/json"]');
    var fieldset = sizeFieldset(box);
    if (!json || !fieldset) return;
    var data;
    try { data = JSON.parse(json.textContent); } catch (e) { return; }
    box.dataset.ready = '1';
    decorate(fieldset, data);
    var update = function () { render(box, fieldset, data); };
    fieldset.addEventListener('change', update);
    fieldset.addEventListener('click', function () { setTimeout(update, 0); });
    new MutationObserver(function () { decorate(fieldset, data); update(); })
      .observe(fieldset, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'aria-selected'] });
    update();
  }

  function boot() { document.querySelectorAll('.pb-size-info').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
